import React from "react";
import AppCard from "@crema/core/AppCard";
import { Box, IconButton } from "@mui/material";
import { Fonts } from "shared/constants/AppEnums";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const InfoWidget = ({ data }) => {
    return (
        <Box sx={{
            height: '100%'
        }}>
            <Link to={data.url}>
                <AppCard
                    sxStyle={{ height: 1, backgroundColor: data.bgColor }}
                    contentStyle={{ px: 8, pt: 8, pb: "32px !important" }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            flex: 1,
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Box
                            sx={{
                                mb: 3,
                                // background: "#EEE",
                                borderRadius: "100%",
                                // height: { xs: "42px", md: "48px", xl: "54px" },
                                // width: { xs: "42px", md: "48px", xl: "54px" },
                                // lineHeight: { xs: "42px", md: "48px", xl: "54px" },
                                textAlign: "center",
                                // p: 5,

                                "& img": {
                                    height: "20px",
                                    width: "20px",
                                },
                            }}
                        >
                            <IconButton
                                sx={{
                                    p: 3,
                                    backgroundColor: data.color,
                                }}
                            >
                                <img src={data.icon} alt="icon" />
                            </IconButton>
                        </Box>
                        <Box
                            sx={{
                                textAlign: "center",
                            }}
                        >
                            <Box
                                component="h3"
                                sx={{
                                    color: "text.primary",
                                    fontWeight: Fonts.MEDIUM,
                                    fontSize: 16,
                                }}
                            >
                                {data.title}
                            </Box>
                        </Box>
                    </Box>
                </AppCard>
            </Link>
        </Box>
    );
};

export default InfoWidget;

InfoWidget.propTypes = {
    data: PropTypes.object,
};
